<template>
  <el-dialog
    v-model="visible"
    :title="title"
    width="400px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    center
    class="payment-modal"
  >
    <div class="payment-content">
      <!-- 价格显示 -->
      <div class="price-section">
        <div class="price-amount">
          <span class="currency">¥</span>
          <span class="amount">{{ price }}</span>
        </div>
        <div class="price-description">{{ description }}</div>
      </div>

      <!-- 支付方式选择 -->
      <div class="payment-methods">
        <div class="payment-method-title">选择支付方式</div>
        
        <!-- 微信支付 -->
        <!-- <div 
          class="payment-method-item"
          :class="{ active: selectedMethod === 'wechat' }"
          @click="selectMethod('wechat')"
        >
          <div class="method-icon">
            <el-icon size="24" color="#07c160">
              <svg viewBox="0 0 1024 1024" width="24" height="24">
                <path fill="#07c160" d="M692.3 347.5c-5.8 0-11.6 0.2-17.3 0.6-1.1-4.9-2.4-9.7-3.9-14.4-23.8-75.2-89.9-130.2-172.1-130.2-82.2 0-148.3 55-172.1 130.2-1.5 4.7-2.8 9.5-3.9 14.4-5.7-0.4-11.5-0.6-17.3-0.6-119.6 0-216.7 97.1-216.7 216.7 0 119.6 97.1 216.7 216.7 216.7 119.6 0 216.7-97.1 216.7-216.7 0-119.6-97.1-216.7-216.7-216.7zM475.6 564.2c-119.6 0-216.7-97.1-216.7-216.7 0-119.6 97.1-216.7 216.7-216.7 119.6 0 216.7 97.1 216.7 216.7 0 119.6-97.1 216.7-216.7 216.7z"/>
                <path fill="#07c160" d="M692.3 347.5c-5.8 0-11.6 0.2-17.3 0.6-1.1-4.9-2.4-9.7-3.9-14.4-23.8-75.2-89.9-130.2-172.1-130.2-82.2 0-148.3 55-172.1 130.2-1.5 4.7-2.8 9.5-3.9 14.4-5.7-0.4-11.5-0.6-17.3-0.6-119.6 0-216.7 97.1-216.7 216.7 0 119.6 97.1 216.7 216.7 216.7 119.6 0 216.7-97.1 216.7-216.7 0-119.6-97.1-216.7-216.7-216.7z"/>
              </svg>
            </el-icon>
          </div>
          <div class="method-info">
            <div class="method-name">微信支付</div>
            <div class="method-desc">推荐有微信账户的用户使用</div>
          </div>
          <div class="method-radio">
            <el-radio v-model="selectedMethod" label="wechat" />
          </div>
        </div> -->


        <!-- 支付宝支付 -->
        <div 
          class="payment-method-item"
          :class="{ active: selectedMethod === 'alipay' }"
          @click="selectMethod('alipay')"
        >
          <div class="method-icon">
            <el-icon size="24" color="#1677ff">
              <svg viewBox="0 0 1024 1024" width="24" height="24">
                <path fill="#1677ff" d="M1024 0v1024H0V0h1024zM959.5 959.5V64.5H64.5v895h895z"/>
                <path fill="#1677ff" d="M832 256H192c-35.3 0-64 28.7-64 64v384c0 35.3 28.7 64 64 64h640c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64zM800 704H224V352h576v352z"/>
                <path fill="#1677ff" d="M320 416h64v192h-64zm160 0h64v192h-64zm160 0h64v192h-64z"/>
              </svg>
            </el-icon>
          </div>
          <div class="method-info">
            <div class="method-name">支付宝支付</div>
            <div class="method-desc">推荐有支付宝账户的用户使用</div>
          </div>
          <div class="method-radio">
            <el-radio v-model="selectedMethod" label="alipay" />
          </div>
        </div>


      </div>
    </div>
    <p style="margin-bottom: 20px;" v-if="configState.payPdfFile.value.data">
      附件下载：
      <a 
      :href="configState.payPdfFile.value.url"
      target="_blank"
      >
        {{ configState.payPdfFile.value.data }}
      </a>
    </p>
    <!-- 底部按钮 -->
    <template #footer>
      <div class="payment-footer">
        <el-button @click="handleCancel" size="large">
          {{ cancelText }}
        </el-button>
        <el-button 
          type="primary" 
          size="large"
          :loading="loading"
          @click="handlePayment"
        >
          {{ confirmText }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { useConfigStore } from '@/stores'
import { storeToRefs } from 'pinia'
import { ref, defineExpose } from 'vue'

import { getWxPayInfo, getAliPayInfo } from '@/api/pay'
import { setWxPayInfo, saveAlipayFormHtml } from '@/utils/common'
import { ElMessage } from 'element-plus'

const configStore = useConfigStore()
const configState = storeToRefs(configStore)

// 显示隐藏弹窗
const visible = ref(false)
// 响应式数据
const selectedMethod = ref('wxpay')

const title = ref('选择支付方式')
const orderNo = ref('')
const price = ref(999999)
const description = ref('支付金额')
const cancelText = ref('取消')
const confirmText = ref('立即支付')
const loading = ref(false)

// Emits 定义
const emit = defineEmits([
  'update:modelValue',
  'cancel',
  'payment'
])

const selectMethod = (method) => {
  selectedMethod.value = method
}

// 取消操作
const handleCancel = () => {
  ElMessage.info('取消支付')
  emit('cancel')
  visible.value = false
}

// 支付操作
const handlePayment = () => {
  if (!selectedMethod.value) {
    ElMessage.warning('请选择支付方式')
    return
  }
  
  // emit('payment', {
  //   method: selectedMethod.value,
  //   packageCode: props.packageCode,
  //   price: props.price,
  //   description: props.description
  // })

  if (selectedMethod.value === 'wxpay') {
      console.log('用户选择了微信支付');
      // 在这里处理微信支付逻辑
      //使用订单信息向后端申请微信支付信息用于扫码支付
        getWxPayInfo({orderNo: orderNo.value}).then( wxResponse => {
          const wxRes = wxResponse.data;
          if(wxRes.code === 200){

            //缓存微信支付信息给支付页面进行扫码使用
            const wxPayInfo = wxRes.data;
            setWxPayInfo(wxPayInfo)
            router.push('/wxPay')

          }else{
            ElMessage({
              message: wxRes.msg,
              type: 'warning'
            })
          }
        })
    } else if (selectedMethod.value === 'alipay') {
      console.log('用户选择了支付宝支付');
      // 在这里处理支付宝支付逻辑
      getAliPayInfo({orderNo: orderNo.value}).then(response => {
        const res = response.data;
        if(res.code === 200){
          const payFormHtml = res.data;
          saveAlipayFormHtml(payFormHtml)
          //跳转到支付宝Form Html内容的承载页
          window.location.href='/alipay'
        }else{
          ElMessage({
            message: res.msg,
            type: 'warning'
          })
        }
      })
    }
    return;
  }


  const showDialog = (titleV = '', orderNoV = '', priceV = 999999, descriptionV = '支付', cancelTextV = '取 消', confirmTextV = '确 定') => {
    title.value = titleV
    orderNo.value = orderNoV
    price.value = priceV
    description.value = descriptionV
    cancelText.value = cancelTextV
    confirmText.value = confirmTextV
    loading.value = false
    visible.value = true
  }

  defineExpose({
    showDialog,
  });

</script>

<style scoped>
.payment-modal {
  border-radius: 12px;
}

.payment-content {
  padding: 20px 0;
}

.price-section {
  text-align: center;
  margin-bottom: 30px;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  color: white;
}

.price-amount {
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-bottom: 8px;
}

.currency {
  font-size: 1.2rem;
  font-weight: 500;
  margin-right: 4px;
}

.amount {
  font-size: 2.5rem;
  font-weight: bold;
  line-height: 1;
}

.price-description {
  font-size: 0.9rem;
  opacity: 0.9;
}

.payment-methods {
  margin-bottom: 20px;
}

.payment-method-title {
  font-size: 1rem;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
}

.payment-method-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border: 2px solid #e4e7ed;
  border-radius: 8px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #fff;
}

.payment-method-item:hover {
  border-color: #409eff;
  background-color: #f0f9ff;
}

.payment-method-item.active {
  border-color: #409eff;
  background-color: #f0f9ff;
}

.method-icon {
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: #f5f7fa;
}

.method-info {
  flex: 1;
}

.method-name {
  font-size: 1rem;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}

.method-desc {
  font-size: 0.85rem;
  color: #909399;
}

.method-radio {
  margin-left: 12px;
}

.payment-footer {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.payment-footer .el-button {
  flex: 1;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .payment-modal {
    width: 90% !important;
    margin: 0 auto;
  }
  
  .price-amount {
    flex-direction: column;
    align-items: center;
  }
  
  .currency {
    margin-right: 0;
    margin-bottom: 4px;
  }
  
  .payment-method-item {
    padding: 12px;
  }
  
  .method-icon {
    width: 32px;
    height: 32px;
    margin-right: 12px;
  }
}
</style> 